import React, { Component, Fragment } from "react";

export default class ЕmployeeСontacts extends Component {
  render() {
    return (
      <Fragment>
        <h1 className="office-h1">Контакты сотрудников</h1>
        <div className="office__coworker-list">
          <div className="coworker-item">
            <div className="coworker-item__name">Мария Терехина </div>
            <div className="coworker-item__position">
              Консультант по франчайзингу
            </div>
            <div className="coworker-item__avatar">
              <img src="/images/coworker-avatar.png" alt="" />
            </div>
            <div className="coworker-item__email">mariya@pzru.ru</div>
            <a href="mailto:mariya@pzru.ru" className="coworker-item__link">
              Написать
            </a>
          </div>
          <div className="coworker-item">
            <div className="coworker-item__name">Мария Терехина </div>
            <div className="coworker-item__position">
              Консультант по франчайзингу
            </div>
            <div className="coworker-item__avatar">
              <img src="/images/coworker-avatar.png" alt="" />
            </div>
            <div className="coworker-item__email">mariya@pzru.ru</div>
            <a href="mailto:mariya@pzru.ru" className="coworker-item__link">
              Написать
            </a>
          </div>
          <div className="coworker-item">
            <div className="coworker-item__name">Мария Терехина </div>
            <div className="coworker-item__position">
              Консультант по франчайзингу
            </div>
            <div className="coworker-item__avatar">
              <img src="/images/coworker-avatar.png" alt="" />
            </div>
            <div className="coworker-item__email">mariya@pzru.ru</div>
            <a href="mailto:mariya@pzru.ru" className="coworker-item__link">
              Написать
            </a>
          </div>
          <div className="coworker-item">
            <div className="coworker-item__name">Мария Терехина </div>
            <div className="coworker-item__position">
              Консультант по франчайзингу
            </div>
            <div className="coworker-item__avatar">
              <img src="/images/coworker-avatar.png" alt="" />
            </div>
            <div className="coworker-item__email">mariya@pzru.ru</div>
            <a href="mailto:mariya@pzru.ru" className="coworker-item__link">
              Написать
            </a>
          </div>
          <div className="coworker-item">
            <div className="coworker-item__name">Мария Терехина </div>
            <div className="coworker-item__position">
              Консультант по франчайзингу
            </div>
            <div className="coworker-item__avatar">
              <img src="/images/coworker-avatar.png" alt="" />
            </div>
            <div className="coworker-item__email">mariya@pzru.ru</div>
            <a href="mailto:mariya@pzru.ru" className="coworker-item__link">
              Написать
            </a>
          </div>
          <div className="coworker-item">
            <div className="coworker-item__name">Мария Терехина </div>
            <div className="coworker-item__position">
              Консультант по франчайзингу
            </div>
            <div className="coworker-item__avatar">
              <img src="/images/coworker-avatar.png" alt="" />
            </div>
            <div className="coworker-item__email">mariya@pzru.ru</div>
            <a href="mailto:mariya@pzru.ru" className="coworker-item__link">
              Написать
            </a>
          </div>
          <div className="coworker-item">
            <div className="coworker-item__name">Мария Терехина </div>
            <div className="coworker-item__position">
              Консультант по франчайзингу
            </div>
            <div className="coworker-item__avatar">
              <img src="/images/coworker-avatar.png" alt="" />
            </div>
            <div className="coworker-item__email">mariya@pzru.ru</div>
            <a href="mailto:mariya@pzru.ru" className="coworker-item__link">
              Написать
            </a>
          </div>
          <div className="coworker-item">
            <div className="coworker-item__name">Мария Терехина </div>
            <div className="coworker-item__position">
              Консультант по франчайзингу
            </div>
            <div className="coworker-item__avatar">
              <img src="/images/coworker-avatar.png" alt="" />
            </div>
            <div className="coworker-item__email">mariya@pzru.ru</div>
            <a href="mailto:mariya@pzru.ru" className="coworker-item__link">
              Написать
            </a>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ЕmployeeСontacts.jsx